import { render, staticRenderFns } from "./plan-courseList.vue?vue&type=template&id=a8740792&"
import script from "./plan-courseList.vue?vue&type=script&lang=js&"
export * from "./plan-courseList.vue?vue&type=script&lang=js&"
import style0 from "./plan-courseList.vue?vue&type=style&index=0&id=a8740792&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports